// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-pro[data-v-67bd4f7b]{display:flex;flex-direction:column;flex-grow:1;overflow:hidden}.search-pro h1[data-v-67bd4f7b]{margin-top:0;margin-right:16px}.search-pro__wrapper[data-v-67bd4f7b]{display:flex;justify-content:space-between;flex-wrap:wrap}.search-pro__map-search-btn[data-v-67bd4f7b]{margin-bottom:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
